// Shim for Node.js events module in browser
class EventEmitter {
    constructor() {
        this._events = {};
    }

    on(event, listener) {
        if (!this._events[event]) {
            this._events[event] = [];
        }
        this._events[event].push(listener);
        return this;
    }

    off(event, listener) {
        if (!this._events[event]) return this;
        this._events[event] = this._events[event].filter(l => l !== listener);
        return this;
    }

    emit(event, ...args) {
        if (!this._events[event]) return false;
        this._events[event].forEach(listener => listener.apply(this, args));
        return true;
    }

    once(event, listener) {
        const onceWrapper = (...args) => {
            this.off(event, onceWrapper);
            listener.apply(this, args);
        };
        return this.on(event, onceWrapper);
    }

    removeListener(event, listener) {
        return this.off(event, listener);
    }

    removeAllListeners(event) {
        if (event) {
            delete this._events[event];
        } else {
            this._events = {};
        }
        return this;
    }

    listeners(event) {
        return this._events[event] || [];
    }

    listenerCount(event) {
        return this.listeners(event).length;
    }

    addListener(event, listener) {
        return this.on(event, listener);
    }
}

export default EventEmitter;
export { EventEmitter };
